import React, { Fragment } from 'react'
import './NotesWindow.scss'
import HrbTranslate from '../../../../components/language/HrbTranslate'
import ContentPlain from '../../../../components/layout/ContentPlain';
import HelpLink from '../../../../components/library/common/HelpLink';
import NotesWindow from './NotesWindow';


const Notes = props => {
    return (
        <Fragment>
            <ContentPlain elementId='messages-description'>
                <div className='columns messages'>
                    <div className='column is-8 is-offset-1'>
                        <div>
                            <h3><HrbTranslate text='Notes.Title' /></h3>
                            <HrbTranslate text='Notes.Description' className='p1' />
                        </div>
                    </div>
                    <div className='column is-2 pt-4'>
                        <HelpLink helpKey='0ProSupport/VDOPro/InternalNotes.htm' textKey='App.HelpLinkText' />
                    </div>
                </div>
            </ContentPlain >
            <NotesWindow />
        </Fragment>)
}

export default Notes